import React, { FC } from 'react';

import { StyledContainer } from './ShaftsToolbar.style';
import TableSearchInput from '../../../app/components/Table/TableSearchInput/TableSearchInput';

import {
  TableToolbarButton,
  TableToolbarButtonsWrapper,
} from '../../../app/components/Table/Table.style';
import { Uploader } from '../../../app/components/Uploader/Uploader';

interface IShaftsToolbar {
  onSearch: (searchTerm: string) => void;
  onExport: () => void;
  onImport: (file: File) => void;
  isExportPending: boolean;
  isPending: boolean;
  filter?: string;
}

const ShaftsToolbar: FC<IShaftsToolbar> = ({
  onSearch,
  onExport,
  onImport,
  isExportPending,
  isPending,
  filter,
}) => {
  return (
    <StyledContainer>
      <TableSearchInput
        onSearch={onSearch}
        label="Search shafts"
        isPending={isPending}
        filter={filter}
        tooltipLabel="You can search by model, manufacturer and SKU"
      />
      <TableToolbarButtonsWrapper>
        <TableToolbarButton
          color="primary"
          variant="contained"
          onClick={onExport}
          pending={isExportPending}
          disabled={isExportPending || isPending}
        >
          Export All
        </TableToolbarButton>
        <Uploader onChange={onImport} isPending={isPending} accept="text/csv" />
      </TableToolbarButtonsWrapper>
    </StyledContainer>
  );
};

export default ShaftsToolbar;
